module.exports = __webpack_public_path__ + "static/media/DeFi_Book_Final_Color-slice.57822009.pdf";